import { render, staticRenderFns } from "./aParityGroup.vue?vue&type=template&id=bb7d9a98"
import script from "./aParityGroup.vue?vue&type=script&lang=js"
export * from "./aParityGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports